module.exports = ".textBio{\n    width: 50% ;\n}\n.creatPlaylist{\n    margin:10px;\n    max-height: 90vh;\n    overflow: scroll\n}\n@media screen and (max-width: 1024px) {\n    .creatPlaylist{\n        max-height: 45vh !important;\n    }\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/playlists/create-playlist/create-playlist.component.css
// module id = ./src/app/playlists/create-playlist/create-playlist.component.css
// module chunks = main